import React, { useState } from "react";
import { req } from "./ServerUtils";
import { Button, IconButton } from "@mui/material";
import { ContentCopy, Delete } from "@mui/icons-material";


const ImagesUploader = ({templateId, templateImages, setTemplateImages}) => {
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState([]);
  

  const handleFiles = (files) => {
    const uploadPromises = Array.from(files).map((file, index) => {
      return new Promise((resolve, reject) => {
        if (file.type.startsWith("image/")) {
          const reader = new FileReader();
          reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
              const formData = new FormData();
              formData.append("file", file);
              formData.append("width", img.width);
              formData.append("height", img.height);
              formData.append("template_id", templateId);
  
              req("/admin/upload-template-image", "POST", formData, false)
                .then((res) => {
                  if (res.error) {
                    reject({ error: res.error, filename: file.name });
                  } else {
                    resolve({ src: res.src, filename: file.name });
                  }
                })
                .catch(reject);
            };
            img.src = event.target.result;
          };
          reader.readAsDataURL(file);
        } else if (file.type === "text/css" || file.type === "font/ttf") {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("template_id", templateId);
  
          req("/admin/upload-template-css", "POST", formData, false)
            .then((res) => {
              if (res.error) {
                reject({ error: res.error, filename: file.name });
              } else {
                resolve({ src: res.src, filename: file.name });
              }
            })
            .catch(reject);
        } else {
          reject({ error: "Unsupported file type", filename: file.name });
        }
      })
        .then((res) => {
          setUploadProgress((prev) => {
            const updated = [...prev];
            updated[index] = res;
            return updated;
          });
        })
        .catch((err) => {
          setUploadProgress((prev) => {
            const updated = [...prev];
            updated[index] = { filename: file.name, error: err.error || "Failed to upload" };
            return updated;
          });
        });
    });
  
    setUploading(true);
  
    Promise.all(uploadPromises).finally(() => {
      setUploading(false);
      setTimeout(() => {
        setUploadProgress([]);
      }, 5000);
    });
  };
  
  
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files) {
      handleFiles(e.dataTransfer.files);
    }
  };

  const handleClick = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    // input.accept = "image/*";
    // accept either image or css
    input.accept = ".jpg,.jpeg,.png,.gif,.svg,.css, .ttf, .avif";
    input.onchange = (e) => {
      if (e.target.files) {
        handleFiles(e.target.files);
      }
    };
    input.click();
  };

  function handleCopy(text) {
    navigator.clipboard.writeText(text);
  }

  function handleDelete(imageUrl) {
    req("/admin/delete-template-image", "POST", JSON.stringify({ 
      template_id: templateId,
      image_url: imageUrl
    }))
      .then((res) => {
        if (res.error) {
          console.error(res.error);
        } else {
          setTemplateImages((prev) => {
            const updated = [...prev];
            updated.splice(updated.indexOf(imageUrl), 1);
            return updated;
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "stretch",
      alignItems: "stretch",
      // border: "1px solid #ccc",
      // borderRadius: "10px",
      padding: 5,
      gap: 5,
      textAlign: "center",
    }}>

      <div style={{
        display: "flex",
        justifyContent: "start",
        flexDirection: "row",
        gap: 10,
        flexWrap: "wrap",
      }}>
        {templateImages.map((imageUrl, index) => (
          <div key={index} style={{ 
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            flexDirection: "column",
            gap: 10,

            marginTop: "10px",
            marginBottom: "10px",
            borderRadius: "10px",
            border: "1px solid #ccc",
            width: "fit-content",
            padding: 5,
            cursor: "pointer",
          }}>
            {imageUrl?.endsWith(".css") && <a href={imageUrl} target="_blank" rel="noreferrer">{imageUrl}</a>}
              
            {!imageUrl?.endsWith(".css") && <img src={`${imageUrl}`} alt={imageUrl} style={{ 
                width: 50, 
                height: 50, 
                objectFit: "cover" 
              }} onClick={() => handleCopy(imageUrl)}/>
            }
            <IconButton onClick={() => handleDelete(imageUrl)} size="small" style={{ color: "rgb(212 118 118)" }}>
              <Delete fontSize="small" />
            </IconButton>
          </div>
        ))}
      </div>

      <div
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        onClick={handleClick}
        style={{
        }}
      >
        {uploading ? (
          <p>Uploading...</p>
        ) : (
          <Button fullWidth variant="outlined" color="secondary">Upload Images/CSS files</Button>
        )}
      </div>
      <div>
        {uploadProgress && Object.keys(uploadProgress).map((key, i) => {
          return (
            <div key={i} style={{
              display: 'flex',
              justifyContent: 'start',
              alignItems: 'center',
              flexDirection: 'row',
              marginTop: '10px',
              marginBottom: '10px',
              padding: '10px',
            }}>
              {uploadProgress[key].src ? (
                <>
                  <div>{uploadProgress[key].filename}: </div>
                  <div>Success!</div>
                </>
              ) : (
                <>
                  <div>{uploadProgress[key].filename}: </div>
                  <div>Failed.</div>
                </>
              )}
          </div>
        )})}
      </div>
    </div>
    
  );
};

export default ImagesUploader;
